<script>
import { asUrlParams } from '../utils';

export default {
  computed: {
    order() {
      return this.$store.state.order;
    },
    url() {
      if (!this.$store.state.order.referralCandy) {
        return null;
      }
      const params = {
        aa: 75,
        a: this.order.request.user.contactEmail,
        b: this.order.request.user.firstName,
        c: this.order.request.user.lastName,
        d: this.order.cost,
        e: 'USD',
        f: this.order.request.user.optInEmail,
        g: this.order.referralCandy.timestamp,
        i: 'en',
        ab: this.order.referralCandy.signature,
      };
      const paramsString = asUrlParams(params).toString();
      return `https://go.referralcandy.com/purchase/${this.order.referralCandy.appId}.js?${paramsString}`;
    },
  },
  mounted() {
    if (!this.url) {
      return;
    }
    const script = document.createElement('script');
    script.setAttribute('src', this.url);
    document.head.appendChild(script);
  },
  render() {
    return null;
  },
};
</script>
